import { createContext } from 'react';
import GlobalStore from 'store';

const GlobalContext = createContext(new GlobalStore());

export default GlobalContext;
